const splitLongWords = (words, maxWordLength = 20) => {
  const splitRegEx = new RegExp(`.{1,${maxWordLength}}`, 'g');
  const wordsArray = words.split(' ')
    .map((word) => {
      const splitWordArray = word.match(splitRegEx);
      if (splitWordArray) {
        return splitWordArray.join('\u200B');
      }
      return '';
    });
  return wordsArray.join(' ');
};

export default splitLongWords;



// WEBPACK FOOTER //
// ./src/utils/splitLongWords.js